export const normalizeClassId = (value) => String(value ?? '')
  .trim()
  .toLowerCase()
  .replace(/\s+/g, '-');

const classNameFor = (entry = {}) => entry?.class ?? entry?.Occupation ?? entry?.Name
  ?? entry?.occupation ?? entry?.name;

export const getClassLevel = (character, classId) => {
  const wanted = normalizeClassId(classId);
  if (!wanted || !Array.isArray(character?.occupation)) return 0;
  return character.occupation.reduce((sum, entry) => {
    if (normalizeClassId(classNameFor(entry)) !== wanted) return sum;
    const level = Number(entry?.Level ?? entry?.level ?? 0);
    return sum + (Number.isFinite(level) && level > 0 ? level : 0);
  }, 0);
};

export const getTotalClassLevel = (character) => [...new Set(
  (Array.isArray(character?.occupation) ? character.occupation : []).map(entry => normalizeClassId(classNameFor(entry || {})))
)].reduce((total, id) => total + getClassLevel(character, id), 0);
